import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output, QueryList,
    SimpleChanges,
    ViewChild, ViewChildren,
} from "@angular/core";
import {OrgBUProjectTeamStructure} from "../../../../models/custom-models/org-buproject-team-structure";
import {EntityInfo} from "../../../../models/custom-models/entity-info";
import {OrgBuProjectTeamStructureService} from "../../Services/org-bu-project-team-structure.service";
import {MatMenu, MatMenuItem, MatMenuTrigger, MenuPositionX} from "@angular/material/menu";
import {
    MatNestedTreeNode,
    MatTree,
    MatTreeNode, MatTreeNodeDef,
    MatTreeNodeOutlet, MatTreeNodeToggle
} from "@angular/material/tree";
import {MatFormField, MatFormFieldAppearance, MatLabel, MatSuffix} from "@angular/material/form-field";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatRadioButton} from "@angular/material/radio";
import {CssClassBasedOnEntityTypeIdPipe} from "../../Pipes/css-class-based-on-entity-type-id.pipe";
import {Constants, NAVBAR_TREE_HEIGHT_CONSTANTS} from "../../../../models/constants";

@Component({
    selector: "app-org-bu-project-team-structure",
    templateUrl: "./org-bu-project-team-structure.component.html",
    styleUrls: ["./org-bu-project-team-structure.component.scss"],
    imports: [
        MatFormField,
        MatMenuTrigger,
        MatLabel,
        MatIcon,
        MatMenu,
        MatInput,
        NgIf,
        NgClass,
        MatTree,
        MatTreeNode,
        MatRadioButton,
        MatNestedTreeNode,
        CssClassBasedOnEntityTypeIdPipe,
        MatTreeNodeDef,
        MatTreeNodeToggle,
        MatMenuItem,
        MatTreeNodeOutlet,
        MatSuffix,
        NgForOf
    ],
    standalone: true,
})
export class OrgBuProjectTeamStructureComponent implements OnChanges {
    @Input() allowedToChangeEntity: boolean = true;
    @Input() dataForTree: OrgBUProjectTeamStructure[] = []; // data for tree
    // Below are the selected entity name and info which are required when parent is sending the selected entity
    @Input() selectedEntityName: string = "";
    @Input() placeHolder: string = "";
    @Input() label: string = "";
    @Input() selectedEntityInfo: EntityInfo | undefined;

    @Input() isApplySelectableFilter: boolean = false; // to apply the selectable filter on the tree
    @Input() selectTeamOnly: boolean = false; // to select only team
    @Input() appearance: MatFormFieldAppearance = "fill";
    @Input() dynamicClasses: string | string[] | Set<string> | { [p: string]: any } | null | undefined;
    @Input() isAllowedToReset: boolean = true;
    @Input() xPosition: MenuPositionX = "before"; // Position of the menu relative to the trigger

    // SelectedEntityChange event emitter to send the selected-entity/OrgBUProjectTeamStructure to the parent
    @Output() selectedEntityChange: EventEmitter<OrgBUProjectTeamStructure> =
        new EventEmitter<OrgBUProjectTeamStructure>();

    @ViewChild("menu") matMenu: MatMenu;
    // Get a reference to the menu trigger directive
    @ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger;

    // Get a reference to the form field element to measure its width
    @ViewChild('triggerElement', { read: ElementRef }) triggerElement: ElementRef;

    dataSource: OrgBUProjectTeamStructure[] = [];
    showTreeStructure: boolean = false;
    isTeamEntity: number;
    getChildren = (node: OrgBUProjectTeamStructure): OrgBUProjectTeamStructure[] =>
        node.children || [];

    // These height are calculated based on the default material radio and label height
    private readonly NODE_HEIGHT = NAVBAR_TREE_HEIGHT_CONSTANTS.Node_Height;
    private readonly START_OFFSET = NAVBAR_TREE_HEIGHT_CONSTANTS.Start_Offset;

    // Map to store node IDs and their actual heights (e.g., {'nodeId123': 60})
    private readonly nodeHeightMap = new Map<number, number>();

    // Query the DOM for all the mat-tree-node elements (or the <li> inside them)
    // We'll query for the mat-radio-button since it wraps the content
    @ViewChildren('treeNode', { read: ElementRef })
    private nodeElements: QueryList<ElementRef> | undefined;

    // Replace flattenedNodes with this lookup map
    private readonly nodeMap = new Map<number, OrgBUProjectTeamStructure>();



    constructor(
        private cdr: ChangeDetectorRef,
        private orgBuProjectTeamStructureService: OrgBuProjectTeamStructureService,
    ) {
        this.isTeamEntity = Constants.EntityTypes.TEAM;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes &&
            changes.dataForTree &&
            changes.dataForTree.currentValue &&
            changes.dataForTree.currentValue.length > 0
        ) {
            this.dataSource = changes.dataForTree.currentValue;
            this.cdr.detectChanges();
        }
        if (changes && changes.selectedEntityInfo) {
            if (this.selectedEntityInfo) {
                let node = this.orgBuProjectTeamStructureService.findNodeBasedOnEntity(
                    this.selectedEntityInfo.entityId,
                    this.selectedEntityInfo.entityTypeId,
                    this.dataForTree,
                );
                if (
                    node?.entityTypeId != this.selectedEntityInfo.entityTypeId ||
                    node?.id != this.selectedEntityInfo.entityId
                ) {
                    this.handleSelectedEntity(node);
                }
                // else{
                //     this.selectedEntityChange.emit(node as OrgBUProjectTeamStructure);
                // }
            }
        }

        if (this.matMenu) {
            this.matMenu.closed.subscribe(() => {
                requestAnimationFrame(() => {
                    this.showTreeStructure = false;
                });
            });
        }
    }

    isNodeSelected(node: OrgBUProjectTeamStructure): boolean {
        if (!this.selectedEntityInfo) {
            return false;
        }
        return this.selectedEntityInfo.entityTypeId == node.entityTypeId && this.selectedEntityInfo.entityId == node.id;
    }

    handleSelectedEntity(node: any) {
        this.matMenu?.closed.emit();
        this.showTreeStructure = false;
        if (!this.selectedEntityInfo) {
            this.selectedEntityName = node.name;
            this.selectedEntityChange.emit(node as OrgBUProjectTeamStructure);
            this.selectedEntityInfo = {
                entityType: node.entityType,
                entityName: node.name,
                entityId: node.id,
                entityTypeId: node.entityTypeId,
            } as EntityInfo;
        } else if (node && (node.id != this.selectedEntityInfo.entityId || node.entityTypeId != this.selectedEntityInfo.entityTypeId)) {
            // In many tree nodes the entity id for org and its project or team is same hence when we check only the id this condition fails, and we are no able to select different entity because they have same id like in case of prod meetings where we can not switch from tse to Platform_Team and vice versa. Therefore, we also have to check if the entityType is also same or not.
            this.selectedEntityName = node.name;
            this.selectedEntityChange.emit(node as OrgBUProjectTeamStructure);
            this.selectedEntityInfo = {
                entityType: node.entityType,
                entityName: node.name,
                entityId: node.id,
                entityTypeId: node.entityTypeId,
            } as EntityInfo;
        }
        this.cdr.detectChanges();
    }

    hasChild = (_: number, node: OrgBUProjectTeamStructure) => !!node.children && node.children.length > 0;

    resetEntity($event: MouseEvent) {
        $event.stopPropagation();
        this.selectedEntityName = "";
        this.selectedEntityInfo = undefined;
        this.selectedEntityChange.emit(undefined);
        this.dataSource = [];
        setTimeout(() => {
            this.dataSource = [...this.dataForTree];
        }, 100);
        this.matMenu?.closed.emit();
    }


    // Add this line to access the tree component and its expansion state
    @ViewChild('tree') tree!: MatTree<OrgBUProjectTeamStructure>;

    private buildNodeIdMap(): void {
        if (!this.dataSource || this.dataSource.length === 0) return;

        this.nodeMap.clear();

        const traverse = (nodes: OrgBUProjectTeamStructure[]) => {
            for (const node of nodes) {
                // Store ALL nodes in the map for easy lookup by ID
                this.nodeMap.set(node.id!, node);

                if (this.hasChild(0, node)) {
                    traverse(node.children as OrgBUProjectTeamStructure[]);
                }
            }
        };

        traverse(this.dataSource);
    }

    ngAfterViewChecked(): void {
        // Only run if the tree structure is visible and we have element references
        if (this.nodeElements && this.showTreeStructure) {
            this.updateNodeHeights();
        }
    }


    count  = 1;

    private updateNodeHeights(): void {
        // Ensure the ID map is built before trying to use it
        if (this.nodeMap.size === 0) {
            this.buildNodeIdMap();
        }

        // Iterate over the elements found in the DOM
        this.nodeElements!.forEach(elRef => {
            const nativeEl = elRef.nativeElement;

            // CRITICAL: Get the ID from the DOM attribute
            const nodeIdString = nativeEl.getAttribute('data-node-id');
            const nodeId = Number(nodeIdString); // Convert back to number

            // Use the ID to get the correct data object
            const renderedNode = this.nodeMap.get(nodeId);

            if (renderedNode) {
                // Read the actual height of the element
                const actualHeight = nativeEl.offsetHeight;

                if (this.nodeHeightMap.get(nodeId) !== actualHeight) {
                    // Only update if the height has changed
                    this.nodeHeightMap.set(nodeId, actualHeight);
                }
            }
        });
    }


    // get the actual node height from the nodeHeightMap
    getActualNodeHeight(node: OrgBUProjectTeamStructure): number {
        const nodeId = node.id;

        if (!nodeId) return 0;
        // Look up the measured height, or default to the NODE_HEIGHT constant (40) if not found yet.
        return this.nodeHeightMap.get(nodeId) || this.NODE_HEIGHT;
    }

    /**
     * Recursively calculates the total expanded height of a given node/branch.
     * @param node The node object to measure.
     * @returns The total occupied height in pixels.
     */
    getTotalExpandedHeight(node: OrgBUProjectTeamStructure): number {

        // Base height for the current node (40px)
        let height = this.getActualNodeHeight(node);

        // Get children
        const children = this.getChildren(node);

        if (children && children.length > 0) {
            // Recursively add the height of all children
            for (const child of children) {
                height += this.getTotalExpandedHeight(child);
            }
        }

        // For a leaf node, height is 40.
        // For a parent with one leaf child, height is 40 (parent) + 40 (child) = 80.
        return height;
    }

    /**
     * Calculates the total vertical distance from the parent to the i-th child's connection point.
     * @param parentNode The parent node containing the children.
     * @param index The 0-based index of the current child node (the target).
     * @returns The total height the dynamic line needs to cover for this child.
     */
    getLineHeightToChild(parentNode: OrgBUProjectTeamStructure, index: number): number {
        const children = this.getChildren(parentNode);
        if (!children || index === 0) {
            // First child's vertical line height is always the START_OFFSET (30px)
            return this.START_OFFSET;
        }

        let accumulatedHeight = 0;

        // Sum the total expanded height of all siblings PRECEDING the current index
        for (let i = 0; i < index; i++) {
            const precedingSibling = children[i];

            // We need the height *consumed* by the preceding sibling's structure,
            // which is its total expanded height.
            accumulatedHeight += this.getTotalExpandedHeight(precedingSibling);

        }

        // In general the node height is 40 but if it exceeds like in case the text is too long then we have to add the half of the exceeding height of the node than normal height.
        if(this.getActualNodeHeight(children[index]) > this.NODE_HEIGHT){
            return accumulatedHeight + this.START_OFFSET + (this.getActualNodeHeight(children[index]) - this.NODE_HEIGHT)/2;
        }

        // The final height for the line is:
        return accumulatedHeight + this.START_OFFSET;
    }

    private readonly COLOR_MAP: { [key: number]: string } = {
        [Constants.EntityTypes.ORG]: Constants.EntityTypeTreeColours.ORG_COLOUR,
        [Constants.EntityTypes.BU]: Constants.EntityTypeTreeColours.BU_COLOUR,
        [Constants.EntityTypes.PROJECT]: Constants.EntityTypeTreeColours.PROJECT_COLOUR,
        [Constants.EntityTypes.TEAM]: Constants.EntityTypeTreeColours.TEAM_COLOUR,
        0: Constants.EntityTypeTreeColours.TEAM_COLOUR
    };

    getNodeColor(node: any): string {
        return this.COLOR_MAP[node.entityTypeId] || this.COLOR_MAP[0];
    }


    /**
     * Deprecated method to open the menu.
     * This method is called by the (click) event from the trigger.
     * @deprecated Use openMenu2() instead.
     */
    openMenu() {
        const rect = this.triggerElement.nativeElement.getBoundingClientRect();
        const {bottom, left} = rect;

        if (this.matMenuTrigger && this.allowedToChangeEntity) {
            // Open the menu first
            this.matMenuTrigger.openMenu();
            setTimeout(() => {
                const menuPanel = document.querySelector(".mat-mdc-menu-panel") as HTMLElement;
                if (menuPanel) {
                    menuPanel.style.left = `${left}px`;
                    menuPanel.style.top = `${bottom}px`;
                    menuPanel.style.width = "100%";
                    menuPanel.style.maxHeight = "300px";
                    menuPanel.style.overflowY = "auto";
                    menuPanel.style.overflowX = "hidden";
                }
            }, 0);
            requestAnimationFrame(() => {
                this.dataSource = [...this.dataForTree];
                this.showTreeStructure = true;
            });
        } else {
            console.error("matMenuTrigger is not defined");
        }
    }


    /**
     * This method is called by the (menuOpened) event from the trigger.
     * It handles custom sizing and performant data loading.
     */
    onMenuOpen2() {
        if (!this.allowedToChangeEntity) {
            // If not allowed to change, immediately close the menu.
            this.matMenuTrigger.closeMenu();
            return;
        }

        if (!this.matMenuTrigger || !this.triggerElement) {
            console.error("matMenuTrigger or triggerElement is not defined");
            return;
        }

        // 1. Set the menu's width to match the form field's width
        const triggerWidth = this.triggerElement.nativeElement.offsetWidth;
        // Find the panel using its unique ID provided by Angular Material
        const panelId = this.matMenuTrigger.menu!.panelId;
        const menuPanel = document.getElementById(panelId!);
        console.log(`Menu panel ID: ${panelId}, Width: ${triggerWidth}`);
        if (menuPanel) {
            menuPanel.style.width = `${triggerWidth+100}px`;
            menuPanel.style.maxHeight = '400px';
            menuPanel.style.overflowY = 'auto';
            menuPanel.style.overflowX = 'auto';
        }

        // 2. Load the tree data inside a requestAnimationFrame for performance
        requestAnimationFrame(() => {
            this.dataSource = [...this.dataForTree];
            this.showTreeStructure = true;
        });
    }
}
